export const STATE_AVAILABLE = 'available';
export const STATE_UNAVAILABLE = 'unavailable';
export const STATE_SELECTED = 'selected';
export const STATE_NOT_DEFINED = 'not-defined';
export const STATE_ASSIGNED = 'assigned';
export const STATE_ASSIGNED_SELECTED = 'assigned-selected';
export const STATE_UNASSIGNED = 'unassigned';
export const STATE_UNASSIGNED_SELECTED = 'unassigned-selected';



// WEBPACK FOOTER //
// ./src/components/venue_items/states.js